import { useT } from '@/app/i18n/client';
import type { ISlotOption } from '@/entities/slot/types';
import { useCurrency } from '@/features/product/contexts/CurrencyContext';
import { cn, utilFromMinorUnit } from '@/lib/utils';

interface IProps {
  slotOptionTitle?: string;
  selectedSlotOptionList?: ISlotOption[];
  slotOptionList?: ISlotOption[];
  handleSelectSlotOption: (option: ISlotOption) => (e: React.MouseEvent<HTMLButtonElement>) => void;
}
export default function SlotOption({
  slotOptionTitle = '',
  selectedSlotOptionList = [],
  slotOptionList = [],
  handleSelectSlotOption,
}: IProps) {
  const { t } = useT('product');

  const currency = useCurrency();

  if (slotOptionList.length === 0) return null;

  return (
    <>
      <div className='mb-12'>
        <h3 className='mb-6 text-xl font-bold text-[#2E2E2E] max-sm:text-lg'>
          {slotOptionTitle || t('options')} <span className='text-red-500'>*</span>
        </h3>
        <div className='flex flex-wrap gap-4'>
          {slotOptionList.map(slotOption => (
            <button
              key={slotOption.idx}
              onClick={slotOption.isActive ? handleSelectSlotOption(slotOption) : undefined}
              className={cn(
                'text-basefont-medium flex items-center justify-between rounded-2xl border px-4 py-3 text-left transition-all duration-300 disabled:cursor-not-allowed disabled:opacity-50 max-sm:text-sm',
                selectedSlotOptionList.some(
                  selectedSlotOption => selectedSlotOption.idx === slotOption.idx,
                )
                  ? 'border-[#0064FF] bg-[#0064FF] text-white'
                  : `hover:border- [#0064FF] border-[#E9ECEF] bg-white text-[#2E2E2E]`,
              )}
              disabled={!slotOption.isActive}
            >
              {slotOption.title}
              {slotOption.price > 0 && (
                <span className='ml-1 text-right text-sm'>
                  ({currency} {utilFromMinorUnit(slotOption.price, currency)})
                </span>
              )}
            </button>
          ))}
        </div>
      </div>
    </>
  );
}
